import { PageLayout } from '@repo/ui/components/page-layout'
import { QueryBreadcrumbs } from '@repo/ui/components/query-breadcrumbs'
import { ScrollArea } from '@repo/ui/scroll-area'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/(private)/(shell)/settings/profile')({
	component: ProfileLayout,
	// On the layout rather than on `index.tsx`, so a sibling settings page
	// added later inherits the crumb the way `admin/route.tsx` already does
	// for its own slices, without repeating the key.
	staticData: {
		breadcrumb: 'profile:page_title'
	}
})

function ProfileLayout() {
	return (
		<PageLayout breadcrumb={<QueryBreadcrumbs />}>
			<ScrollArea className='min-h-0 flex-1'>
				<div className='flex flex-col gap-8 px-6 pt-4 pb-6'>
					<Outlet />
				</div>
			</ScrollArea>
		</PageLayout>
	)
}
